import { NormaliseCheck as NormaliseCheckModel } from '@/api';

import { ActionClass } from '../activity-log.constant';
import { ActivityLogDetail } from './activity-log-detail.component';

interface NormaliseCheckProps {
  action: ActionClass;
  item: string;
  normaliseObject: NormaliseCheckModel;
}

export function NormaliseCheck({ action, item, normaliseObject }: NormaliseCheckProps) {
  return (
    <div className="pb-2">
      {Object.keys(normaliseObject).map((normalsItem) => (
        <ActivityLogDetail
          key={normalsItem}
          action={action}
          fieldName={normalsItem}
          title={`${item} > ${normaliseObject[normalsItem].value}`}
          value={normaliseObject[normalsItem].defaultBool}
        />
      ))}
    </div>
  );
}
